export default "__VITE_ASSET__CWBzBxP___"